<template>
  <div class="category-chart chart-w">
    <div class="category-chart__wrapper">
      <Apexchart
        :key="refreshCounter"
        :options="chartOptions"
        :series="allCategories?.length ? toRaw(series) : []"
        :height="stylesChart.heightAreaChart"
      />
    </div>

    <div class="category-chart__menu">
      <div class="category-chart__menu-left">
        <div class="category-chart__title">
          {{ t('categories_dynamic_chart.title') }}
        </div>
      </div>

      <div
        id="chart-control"
        class="category-chart__menu-right"
      >
        <RefreshIcon @click="loadData" />
        <CalendarInput v-model="date" />
        <RubricList
          v-if="allCategories?.length"
          :selected-chart="2"
          :active-store="statStorage"
          :date="date"
          stop-load-on-clear
          @clearRubrics="clearRubrics"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, toRaw } from "vue";
import { useNewsStatDynamicCategoryStore } from "@/store/Analytic/chart/news-stat-dynamic-category";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { stylesChart } from "@/tools/tooltipChart";
import VueApexCharts from "vue3-apexcharts";
import RubricList from "@/components/AnalyticsPage/AnalyticsGeneral/Charts/blocks/RubricList.vue";
import useFilterDate from "@/mixins/apexChart/filterDate";
import useAreaChart from "@/mixins/apexChart/areaChart";
import { t } from "@/controllerLK/GlobusLocalization";
import CalendarInput from "@/components/AnalyticsPage/AnalyticsGeneral/Charts/blocks/CalendarInput.vue";
import RefreshIcon from "@/components/Icons/RefreshIcon.vue";

export default {
  name: "RubricDynamicChart",
  components: {CalendarInput, Apexchart: VueApexCharts, RubricList, RefreshIcon },
  setup() {
    const statStorage = useNewsStatDynamicCategoryStore();
    const newsStorage = useNewsFeedStore();
    const refreshCounter = ref(0);

    const categories = computed(() => {
      const labelsSet = new Set();
      (statStorage?.items || []).forEach((item) => {
        if (item?.data) {
          item.data.forEach((point) => {
            labelsSet.add(point.date);
          });
        }
      });
      return Array.from(labelsSet).sort((a, b) => new Date(a) - new Date(b));
    });

    const allCategories =  computed(() => newsStorage.filterCategories.list);

    const series = computed(() => {
      if (!statStorage.items?.length) return [];
      
      // Получаем все уникальные даты из всех серий
      const allDates = categories.value;
      
      return (statStorage.items || []).map((item) => {
        const categoryObj = allCategories.value.find((cat) => cat.id == item.name);
        const categoryName = categoryObj?.name ? categoryObj.name : item.id;
        
        // Создаем Map для быстрого поиска значений по датам
        const dataMap = new Map();
        item.data.forEach(point => {
          dataMap.set(point.date, point.count);
        });
        
        // Создаем данные для всех дат
        const seriesData = allDates.map(date => ({
          x: date,
          y: dataMap.get(date) || null // null вместо 0 для пропущенных значений
        }));
        
        return {
          name: categoryName,
          data: seriesData
        };
      });
    });

    const { chartOptions } = useAreaChart(
      {
        titleText: t("categories_dynamic_chart.title"),
      },
      categories,
      series
    );

    const { date } = useFilterDate(loadData);

    onMounted(async () => {
      await loadData();
    });

    async function loadData() {
      await statStorage.loadStat(date.value?.[0], date.value?.[1]);
    }

    const clearRubrics = () => {
      statStorage.items = [];
      refreshCounter.value++;
      chartOptions.value = {
        ...chartOptions.value,
        noData: { text: t("common_chart.no_data.short_text") },
      };
    };

    return { allCategories, chartOptions, clearRubrics, loadData, refreshCounter, series, stylesChart, date, statStorage, toRaw, t };
  },
};
</script>

<style lang="scss" scoped>
.category-chart {
  &__title {
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
  }


  &__menu {
    display: flex;
    position: absolute;
    align-items: center;
    top: 24px;
    height: 42px;
    width: 100%;
    left: 0;
    padding: 0 24px;
    justify-content: space-between;

    &-left {
      display: flex;
      gap: 20px;
    }

    &-right {
      display: flex;
      gap: 14px;
    }
  }
}

.apexcharts-menu-open {
  margin-top: 15px;
}
</style>
